import apiClient from './client';
import { locationConsentApiUrl } from '../utils/runtime';

export function fetchLocationConsent() {
  return apiClient.get(locationConsentApiUrl);
}

export function saveLocationConsent(consent) {
  return apiClient.post(locationConsentApiUrl, { consent });
}
